<div>
  <ng-container *ngIf="action">
    <div id="loading_box">
      <div class="loading content_loading">
        <div class="animation6" style="right: 40%;">
          <div class="shape shape-1"></div>
          <div class="shape shape-2"></div>
          <div class="shape shape-3"></div>
          <div class="shape shape-4"></div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
